import type { ServiceAppointment } from '@quorum/models/xs-resource';

// A service appointment's embedded vehicle is optional — appointments can be returned without one —
// so every vehicle field is guarded. Reading it unguarded crashed the whole sales-planner activity
// list when an appointment had no embedded vehicle.
export const buildServiceAppointmentObjectives = (appointment: ServiceAppointment): string => {
  const vehicle = appointment.embedded ? appointment.embedded.vehicle : null;
  const serviceAdvisor = appointment.embedded ? appointment.embedded.serviceAdvisorAssociate : null;

  return `${vehicle ? vehicle.year : ''} ${vehicle ? vehicle.make : ''} ${vehicle ? vehicle.model : ''} ${
    serviceAdvisor != null ? ' - ' + serviceAdvisor.lastName + ', ' + serviceAdvisor.firstName : ''
  }`;
};
